module.exports = __webpack_public_path__ + "static/media/shape_U.ddcf6ad6.glb";